import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  TextField,
} from "@mui/material";
import { useLocation, Redirect } from "react-router-dom";
import { callAPI } from "../../../../../App/Helpers/callApi";
import Signifier from "../../../../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../../App/State/Slices/SelectedCareersClientSlice";
import {
  editLocation,
  getAddress,
  getCoords,
  getCountries,
} from "../../../LocationsService";
import { basicSort } from "../../../../../App/Helpers/BasicSort";
import DropdownSearch from "../../../../../App/Components/Dropdown/DropdownSearch";

function ManageLocationDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    error: {
      color: theme.palette.error.main,
    },
    copy: {
      color: theme.palette.primary.copy,
    },
  }));

  const classes = useStyles();

  let location = useLocation();
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [processing, setProcessing] = useState(false);
  const selectCareersClient = useSelector(selectCareersClientValue);
  const [inputError, setInputError] = useState(false);
  const [clientId, setClientId] = useState("");

  const [name, setName] = useState("");
  const [number, setNumber] = useState("");
  const [brand, setBrand] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [address3, setAddress3] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");
  const [pageURL, setPageURL] = useState("");
  const [newCityName, setNewCityName] = useState("");
  const [locationId, setLocationId] = useState("");
  const [addressId, setAdressId] = useState("");

  const [countries, setCountries] = useState([]);
  const [divisons, setDivisions] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState({});
  const [selectedDivision, setSelectedDivision] = useState({});
  const [selectedCity, setSelectedCity] = useState({});

  const [sharedLocations, setSharedLocations] = useState([]);

  const updateAdded = (index) => {
    var copy = [...sharedLocations];
    copy[index].checked = !copy[index].checked;

    setSharedLocations(copy);
  };

  const checkEntered = () => {
    if (
      name === "" ||
      postalCode === "" ||
      address1 === "" ||
      selectedCity?.name === undefined ||
      selectedCountry?.name === undefined ||
      selectedDivision?.name === undefined
    ) {
      return false;
    }
    if (selectedCity.name === "+ Add New City" && newCityName === "") {
      return false;
    }
    return true;
  };

  function addCoords() {
    if (
      selectedCountry?.name === undefined ||
      selectedDivision?.name === undefined ||
      selectedCity?.name === undefined
    ) {
      alert("Please enter Country, Division, and City");
      return;
    }

    if (selectedCity?.name === "+ Add New City" && newCityName === "") {
      alert("Please enter Country, Division, and City");
      return;
    }

    var reqAdd = address1 === "" ? " " : address1;
    var reqPostCode = postalCode === "" ? " " : postalCode;
    var reqCity =
      selectedCity?.name === "+ Add New City" ? newCityName : selectedCity.name;
    getCoords(reqAdd, reqCity, selectedDivision.name, reqPostCode).then(
      (response) => {
        setLatitude(response.key);
        setLongitude(response.value);
      }
    );
  }

  function saveLocation() {
    if (!checkEntered()) {
      setInputError(true);
      return;
    }

    var updateLocations = [];
    for (var x in sharedLocations) {
      if (sharedLocations[x].checked) {
        updateLocations.push(sharedLocations[x].id);
      }
    }

    let data = {
      Id: locationId,
      ClientId: selectCareersClient.id,
      CityID: selectedCity.id,
      DivisionID: selectedDivision.id,
      CountryID: selectedCountry.id,
      AddressID: addressId,
      Name: name,
      City:
        selectedCity?.name === "+ Add New City" ||
        selectedCity?.name === undefined
          ? newCityName
          : selectedCity.name,
      StoreNumber: number,
      Brand: brand,
      AddressLine1: address1,
      AddressLine2: address2,
      AddressLine3: address3,
      CityAbbreviation: selectedCity.Abbreviation,
      DivisionAbbreviation: selectedDivision.Abbreviation,
      CountryName: selectedCountry.name,
      CountryAbbreviation: selectedCountry.Abbreviation,
      CountryCode: selectedCountry.Code,
      ZipCode: postalCode,
      Longitude: longitude,
      Latitude: latitude,
      LocationPage: pageURL,
      UpdateLocationIDs: updateLocations,
    };

    callAPI(
      editLocation(data),
      "Location Saved",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    );
  }

  useEffect(() => {
    getCountries().then((response) => {
      response.sort((a, b) => {
        const order = basicSort(a.name, b.name);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
      setCountries(response);
    });
  }, []);

  useEffect(() => {
    for (var i in countries) {
      if (
        countries[i].id === location.state?.address?.city?.division?.country.id
      ) {
        setSelectedCountry(countries[i]);
        return;
      }
    }
  }, [countries]);

  useEffect(() => {
    for (var i in divisons) {
      if (divisons[i].id === location.state?.address?.city?.division.id) {
        setSelectedDivision(divisons[i]);
        return;
      }
    }
  }, [divisons]);

  useEffect(() => {
    for (var i in cities) {
      if (cities[i].id === location.state?.address?.city.id) {
        setSelectedCity(cities[i]);
        return;
      }
    }
  }, [cities]);

  useEffect(() => {
    if (selectedCountry?.divisions !== undefined) {
      selectedCountry.divisions.sort((a, b) => {
        const order = basicSort(a.name, b.name);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
    }
    setDivisions(
      selectedCountry?.divisions === undefined ? [] : selectedCountry.divisions
    );
    setSelectedDivision({});
    setSelectedCity({});
  }, [selectedCountry]);

  useEffect(() => {
    if (selectedDivision?.cities !== undefined) {
      selectedDivision.cities.sort((a, b) => {
        const order = basicSort(a.name, b.name);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
    }
    setCities(
      selectedDivision?.cities === undefined
        ? [{ name: "+ Add New City" }]
        : [{ name: "+ Add New City" }].concat(selectedDivision.cities)
    );
    setSelectedCity({});
  }, [selectedDivision]);

  useEffect(() => {
    setNewCityName("");
  }, [selectedCity]);

  useEffect(() => {
    getAddress(location.state?.address?.id, selectCareersClient.id).then(
      (response) => {
        response.locations.forEach((row) => (row.checked = true));
        setSharedLocations(response.locations);
      }
    );
    setName(location.state?.name);
    setNumber(location.state?.storeNumber);
    setBrand(location.state?.brand);
    setAddress1(location.state?.address?.line1);
    setAddress2(location.state?.address?.line2);
    setAddress3(location.state?.address?.line3);
    setPostalCode(location.state?.address?.zipCode);
    setLongitude(location.state?.address?.longitude);
    setLatitude(location.state?.address?.latitude);
    setPageURL(location.state?.locationPage);
    setLocationId(location.state?.id);
    setAdressId(location.state?.address?.id);
    setClientId(location.state?.clientId);
  }, []);

  if (location.state === null || location.state === null) {
    return <Redirect to="/locations" />;
  }

  if (selectCareersClient.id !== clientId && clientId !== "") {
    return <Redirect to="/locations" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Location Detailed
        </h1>
        <div className={classes.root}>
          {sharedLocations.length > 1 ? (
            <Grid className={classes.cardContainer}>
              <Card className={classes.card}>
                <CardContent>
                  <FormHelperText
                    className={classes.error}
                    style={{ fontWeight: "bold" }}
                  >
                    Warning - The address is shared by multiple locations Select
                    the locations you want to update the address for.
                  </FormHelperText>
                  {sharedLocations.map((ref, index) =>
                    ref.id !== locationId ? (
                      <Grid item xs={12} sm={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={ref.checked}
                              onChange={() => updateAdded(index)}
                            />
                          }
                          label={ref.name}
                        />
                      </Grid>
                    ) : null
                  )}
                </CardContent>
              </Card>
            </Grid>
          ) : null}
          <Grid className={classes.cardContainer}>
            <Card className={classes.card}>
              <CardContent>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Name"
                      label="Name"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={name}
                      error={inputError && name === ""}
                      onChange={(e) => setName(e.target.value)}
                    />
                    {inputError && name === "" && (
                      <FormHelperText className={classes.error}>
                        Name Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Number"
                      label="Number"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={number}
                      onChange={(e) => setNumber(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Brand"
                      label="Brand"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={brand}
                      onChange={(e) => setBrand(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Address Line 1"
                      label="Address Line 1"
                      variant="standard"
                      fullWidth
                      required
                      error={inputError && address1 === ""}
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={address1}
                      onChange={(e) => setAddress1(e.target.value)}
                    />
                    {inputError && address1 === "" && (
                      <FormHelperText className={classes.error}>
                        Address Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Address Line 2"
                      label="Address Line 2"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={address2}
                      onChange={(e) => setAddress2(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Address Line 3"
                      label="Address Line 3"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={address3}
                      onChange={(e) => setAddress3(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DropdownSearch
                      items={countries}
                      property="name"
                      title="Countries"
                      handleChange={(value) => setSelectedCountry(value)}
                      currValue={selectedCountry}
                      error={inputError && selectedCountry?.name === undefined}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DropdownSearch
                      items={divisons}
                      property="name"
                      title="Division"
                      handleChange={(value) => setSelectedDivision(value)}
                      currValue={selectedDivision}
                      error={inputError && selectedDivision?.name === undefined}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <DropdownSearch
                      items={cities}
                      property="name"
                      title="Cities"
                      handleChange={(value) => setSelectedCity(value)}
                      currValue={selectedCity}
                      error={
                        (inputError && selectedCity?.name === undefined) ||
                        (inputError &&
                          selectedCity?.name === "+ Add New City" &&
                          newCityName === "")
                      }
                    />
                  </Grid>
                  {selectedCity?.name === "+ Add New City" ? (
                    <Grid item xs={12} sm={6}>
                      <TextField
                        placeholder="New City Name"
                        label="New City Name"
                        variant="standard"
                        fullWidth
                        aria-required
                        error={inputError && newCityName === ""}
                        InputProps={{
                          className: classes.copy,
                        }}
                        value={newCityName}
                        onChange={(e) => setNewCityName(e.target.value)}
                      />
                      {inputError && newCityName === "" && (
                        <FormHelperText className={classes.error}>
                          City Required
                        </FormHelperText>
                      )}
                    </Grid>
                  ) : null}
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Postal Code"
                      label="Postal Code"
                      variant="standard"
                      fullWidth
                      required
                      error={inputError && postalCode === ""}
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={postalCode}
                      onChange={(e) => setPostalCode(e.target.value)}
                    />
                    {inputError && postalCode === "" && (
                      <FormHelperText className={classes.error}>
                        Postal Code Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Latitude"
                      label="Latitude"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={latitude}
                      onChange={(e) => setLatitude(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      placeholder="Longitude"
                      label="Longitude"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={longitude}
                      onChange={(e) => setLongitude(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Button
                      style={{ marginTop: "10px" }}
                      type="submit"
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={() => addCoords()}
                    >
                      {" "}
                      Get Coordinates
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      placeholder="Location's Page URL"
                      label="Location's Page URL"
                      variant="standard"
                      fullWidth
                      required
                      InputProps={{
                        className: classes.copy,
                      }}
                      value={pageURL}
                      onChange={(e) => setPageURL(e.target.value)}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    container
                    justifyContent="flex-end"
                  >
                    <Button
                      style={{ marginTop: "20px", marginRight: "8px" }}
                      className={classes.sensitiveButton}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() => saveLocation()}
                    >
                      Save Information
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </div>
      </div>
    </>
  );
}

export default ManageLocationDetailed;
